import styled from 'styled-components';

/* eslint-disable import/prefer-default-export */
export const Slide = styled.div`
  width: 100vw;
  margin-left: ${(props) => props.cut}px;
  margin-right: -${(props) => props.cut}px;
  height: auto;
  display: block;
`;
